import React from 'react';
import styled from 'styled-components';

export const FieldableTooltipContent = () => {
  return (
    <div>
      <div>Use this event only when one or more of these conditions are true:</div>
      <List>
        <li>One or more defenders made a legitimate attempt to catch the ball</li>
        <li>The ball landed in foul territory on the field</li>
        <li>The ball landed in the stands at a catchable distance</li>
      </List>

      <div>Do not use this event for:</div>
      <ListNoMargin>
        <li>Grounder foul balls</li>
        <li>Uncatchable line drive foul balls</li>
      </ListNoMargin>
    </div>
  );
};

const List = styled.ol`
  padding-left: 14px;
`;

const ListNoMargin = styled(List)`
  margin-bottom: 0;
`;
